import {
  IAttendee,
  IMeeetingAgenda,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { useMemo } from 'react'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { useTableActions } from '../../../hooks/useTableActions'
import { StyledTable } from '../../styledComponents/styledTable/StyledTable'

import { getAgendaColumns } from './helpers/getAgendaColumns'
import { getDataWithChangedFields } from './helpers/getDataWithChangedFields'
import { getParticipantsCrud } from './helpers/getParticipantsCrud'
import { useSubscribeOnMeetingTime } from './hooks/useSubscribeOnMeetingTime'

import styles from './MeetingAgenda.module.scss'

interface IProps {
  data: IMeeetingAgenda[]
  updateFormData: (data: TComplexSectionData) => void
  meetingDateTime: string
  hpAttendees: IAttendee[]
  accountAttendees: IAttendee[]
}

export const MeetingAgenda = ({
  data,
  updateFormData,
  meetingDateTime,
  hpAttendees,
  accountAttendees,
}: IProps) => {
  useSubscribeOnMeetingTime({ data, meetingDateTime, updateFormData })
  const { onChange, canAddNewRow, addRow, deleteRow, deleteLastRow } =
    useTableActions<IMeeetingAgenda>({
      updateFormData,
      data,
      newEmptyRow: { Time: 0, Presenter: '', Schedule: { Start: null, End: null }, Topic: '' },
      canAddNewRowCondFn: (el) => !el.Time && !el.Topic && !el.Presenter,
      changeComputedFieldsByIndexFn: getDataWithChangedFields(meetingDateTime),
    })

  const participantsCrud = useMemo(
    () => getParticipantsCrud({ hpAttendees, accountAttendees }),
    [hpAttendees, accountAttendees]
  )

  const { columns } = useMemo(() => {
    const columns = getAgendaColumns({ onChange, participantsCrud })
    return { columns }
  }, [data, participantsCrud])

  return (
    <div className={styles.root}>
      <StyledTable<IMeeetingAgenda>
        title={getFormedEltTranslation('agenda-table')}
        columns={columns}
        items={data}
        addRow={addRow}
        deleteLastRow={deleteLastRow}
        deleteRow={deleteRow}
        canAddNewRow={canAddNewRow}
        maxLen={4}
      />
    </div>
  )
}
